import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useUpdateForAttendeeResponseMutation = ({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data?: Api.IEventRegistrationSurveyResponse) => void;
}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ isAttending, id }: { isAttending: boolean; id: string }) => {
			return userSession.webServiceHelper.callAsync<Api.IEventRegistrationSurveyResponse>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `survey/eventRegistration/response/${id}/isAttending`,
				}),
				'PUT',
				`${isAttending}`
			);
		},
		onError,
		onSuccess,
	});
};
